import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgBucketElevator = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 65,
	height: 200,
	viewBox: "0 0 65.0 200.0",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M 25.0 0.0 L 45.0 0.0 L 45.0 185.0 L 65.0 185.0 L 45.0 200.0 L 25.0 200.0 L 25.0 15.0 L 0.0 15.0 Z",
		fill: "none",
		stroke: "currentColor",
		strokeWidth: 1
	})
});
export default SvgBucketElevator;
